import React from 'react'
import HeartIcon from '../../../asserts/icons/physical-assessment/heart_icon.svg'
import '../styles/HRZStage.css'

const getSum = (arr) => arr.reduce((a, b) => a + b, 0)

const getLargestNumInArrayIndex = (array) => {
    return array.indexOf(Math.max.apply(Math, array))
}

const roundPercentageTotals = (numArr) => {
    const totalPercentage = getSum(numArr)

    if (totalPercentage !== 100 && totalPercentage !== 0) {
        const index = getLargestNumInArrayIndex(numArr)
        numArr[index] = Number(numArr[index] - (totalPercentage - 100))
    }

    return numArr
}

function HeartRateZones({ activityDetail = {} }) {
    const heartRateZoneSource =
        Array.isArray(activityDetail.heartRateZoneSource) && activityDetail.heartRateZoneSource.length === 5
            ? activityDetail.heartRateZoneSource.map((v) => Number(v) || 0)
            : new Array(5).fill(0)

    const heartRateZoneDefinition =
        Array.isArray(activityDetail.heartRateZoneDefinition) && activityDetail.heartRateZoneDefinition.length === 5
            ? activityDetail.heartRateZoneDefinition.map((v) => v || '')
            : new Array(5).fill('')

    const zoneLabels = ['Z1', 'Z2', 'Z3', 'Z4', 'Z5']
    const zoneDescriptions = ['Warm Up', 'Easy', 'Aerobic', 'Threshold', 'Maximum']
    const zoneColors = [
        'rgba(255,184,0,0.6)',
        'rgba(255,149,51,.7)',
        'rgba(255,107,0,.8)',
        'rgba(255,88,51,.9)',
        '#FF3D00'
    ]

    const max = Math.max(...heartRateZoneSource, 1)

    const durations = heartRateZoneSource.map((s) => {
        const safeSeconds = Number(s) || 0
        const hours = Math.floor(safeSeconds / 3600)
        const minutes = Math.round((safeSeconds % 3600) / 60)
        return `${hours}h ${minutes}m`
    })

    const durationMinutes = heartRateZoneSource.map((s) => Math.round((Number(s) || 0) / 60))
    const total = getSum(durationMinutes) || 1

    const percentages = roundPercentageTotals(
        durationMinutes.map((m) => Math.round(((m || 0) * 100) / total))
    )

    const displayZones = zoneLabels.map((label, index) => ({
        label,
        description: zoneDescriptions[index],
        color: zoneColors[index],
        definition: heartRateZoneDefinition[index],
        time: durations[index],
        percentage: percentages[index],
        width: ((heartRateZoneSource[index] || 0) / max) * 205
    }))

    const reversedZones = [...displayZones].reverse()

    return (
        <div className="activity-heart-rate-zone-container">
            <div className="heart-rate-title">
                <img src={HeartIcon} alt="Heart" />
                <span>Heart Rate Zones</span>
            </div>

            {reversedZones.map((zone, idx) => (
                <div key={idx} className="activity-heart-rate-zone">
                    <div
                        style={{
                            background: zone.color,
                            width: `${zone.width}px`,
                            height: '40px',
                            borderRadius: '4px',
                            borderLeft: zone.width > 0 ? 'none' : `1px solid ${zone.color}`
                        }}
                    />
                    <div className="activity-heart-rate-info-container">
                        <span className="time">
                            {zone.time} ({zone.percentage || 0}%)
                        </span>
                        <span className="sub-content">
                            {zone.description} - {zone.label}{' '}
                            <span className="definition">{zone.definition}</span>
                        </span>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default HeartRateZones
